import { Separator } from "@/components/ui/separator";
import { Phone, Mail } from "lucide-react";

export default function Footer({ data }) {
  if (!data) return null;

  const handleNavClick = (e, href) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="border-t border-border py-12 md:py-16" data-testid="footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-8">
          {/* Brand */}
          <div className="md:col-span-5">
            <span className="font-heading text-lg text-foreground">
              White Glove Privacy
            </span>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed max-w-sm">
              {data.tagline}
            </p>
            <div className="mt-5 flex flex-col gap-2">
              {data.contact_email && (
                <a
                  href={`mailto:${data.contact_email}`}
                  className="inline-flex items-center gap-2 text-sm text-foreground hover:text-foreground/70"
                  data-testid="footer-email"
                >
                  <Mail className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
                  <span className="font-mono text-sm">{data.contact_email}</span>
                </a>
              )}
              {data.contact_phone && (
                <a
                  href={`tel:${data.contact_phone.replace(/[^+\d]/g, '')}`}
                  className="inline-flex items-center gap-2 text-sm text-foreground hover:text-foreground/70"
                  data-testid="footer-phone"
                >
                  <Phone className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
                  <span className="font-mono text-sm">{data.contact_phone}</span>
                </a>
              )}
            </div>
          </div>

          {/* Nav Links */}
          <div className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted-foreground mb-4">
              Navigation
            </p>
            <nav className="flex flex-col gap-2">
              {data.links?.map((link, i) => (
                <a
                  key={i}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-sm text-foreground hover:text-foreground/70"
                  data-testid={`footer-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Legal Links */}
          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted-foreground mb-4">
              Legal
            </p>
            <nav className="flex flex-col gap-2">
              {data.legal?.map((link, i) => (
                <a
                  key={i}
                  href={link.href}
                  className="text-sm text-muted-foreground hover:text-foreground"
                  data-testid={`footer-legal-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} White Glove Privacy. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground/60 font-mono">
            Built with care for your privacy.
          </p>
        </div>
      </div>
    </footer>
  );
}
